/**
 * shift usecase の依存（DI）。
 */
import { shiftGateway } from "@/infrastructure/gateways";
import type { ShiftGateway } from "@/domain/repositoryInterface/ShiftGateway";

export interface ShiftDeps {
  gateway: ShiftGateway;
}

export const shiftDeps: ShiftDeps = { gateway: shiftGateway };
